import { html } from 'lit';
import componentStyles from './table.css.lit.ts';
import { OutlineElement } from '../../base/outline-element/outline-element.ts';

export default class Table extends OutlineElement {
  static styles = [super.styles, componentStyles];

  static get properties() {
    return {
      /**
       * HTML Markup to render
       */
      markup: { type: String },
    };
  }

  render() {
    return html`<div class="table__wrapper"><slot></slot></div>`;
  }
}
customElements.define('hf-table', Table);
